export const paramsOfTextureReducer = (state = "1915_LJ034205", action) => {
  switch (action.type) {
    case "PARAMS_TEXTURE":
      return action.payload;
    default:
      return state;
  }
};

export const locationOfCarpetReducer = (state = true, action) => {
  switch (action.type) {
    case "RESET_POSITION":
      return !state;
    default:
      return state;
  }
};

export const secendCarpetReducer = (state = false, action) => {
  switch (action.type) {
    case "SECOND_CARPET":
      return !state;
    default:
      return state;
  }
};

export const sizeChangeReducer = (state = "2.0x3.0", action) => {
  switch (action.type) {
    case "SIZE_CHANGE":
      return action.payload;
    default:
      return state;
  }
};
